const ContactFormComponent = () => {
  return null;
};

export default ContactFormComponent;
